import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportOptionsEditorComponent } from './component/transport-options-editor.component';
import { MaterialModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DictionaryModule } from '@sdbn/appclient';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { TransportOptionParameterComponent } from './transport-option-parameter/transport-option-parameter.component';
import { TransportOptionParameterSelectionComponent } from './transport-option-parameter-selection/transport-option-parameter-selection.component';



@NgModule({
  declarations: [
    TransportOptionsEditorComponent,
    TransportOptionParameterComponent,
    TransportOptionParameterSelectionComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ],
  exports: [
    TransportOptionsEditorComponent
  ]
})
export class TransportOptionsEditorModule { }
